import { render } from "./question.vue?vue&type=template&id=3a298dd5&scoped=true"
import script from "./question.vue?vue&type=script&lang=js"
export * from "./question.vue?vue&type=script&lang=js"

import "./question.vue?vue&type=style&index=0&id=3a298dd5&scoped=true&lang=scss"

import exportComponent from "/Users/bill/rongge/code/已售项目/20340305/front/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a298dd5"]])

export default __exports__